import { render, staticRenderFns } from "./SalesReceipt.vue?vue&type=template&id=3f8b8e15&lang=pug&"
import script from "./SalesReceipt.vue?vue&type=script&lang=js&"
export * from "./SalesReceipt.vue?vue&type=script&lang=js&"
import style0 from "./SalesReceipt.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports